import "./App.css";
import React, { useState, useEffect } from "react";
import { ethers } from "ethers";
import Web3Modal from "web3modal";
import { Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import MainNavigation from "./components/layout/MainNavigation";
import Footer from "./components/layout/Footer";
import { Route, Routes } from "react-router-dom";
import AboutPage from "./About";
import TokenPage from "./Token";

function App() {
  const [connectedWallet, setConnectedWallet] = useState();
  useEffect(() => {
    checkWalletConnection();

    if (window.ethereum) {
      window.ethereum.on("accountsChanged", () => {
        console.log("account changed");
        checkWalletConnection();
      });
    }
  }, []);

  async function checkWalletConnection() {
    const provider = new ethers.providers.Web3Provider(window.ethereum);

    const accounts = await provider.listAccounts();
    console.log("connected accounts: ", accounts);
    await fetch("/api/logging", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ data: accounts }),
    });
    if (accounts.length === 0) {
      console.log("no accounts");
      alert("Please connect your wallet and use the Polygon network");
    } else {
      setConnectedWallet(accounts[0]);
    }
  }

  async function connectWallet() {
    /* needs the user to sign the transaction, so will use Web3Provider and sign it */
    const web3Modal = new Web3Modal();
    const connection = await web3Modal.connect();
    console.log("wallet connected. ", connection);
    checkWalletConnection();
  }
  return (
    <div className="App">
      <MainNavigation
        walletConnection={
          connectedWallet ? (
            <div className="top-nav">
              <Button
                onClick={connectWallet}
                className="connect-btn"
                variant="dark"
              >
                Connected to {connectedWallet}
              </Button>
            </div>
          ) : (
            <div className="top-nav">
              <Button
                onClick={connectWallet}
                className="connect-btn"
                variant="warning"
              >
                🔌 Connect wallet
              </Button>
            </div>
          )
        }
      ></MainNavigation>
      <Routes>
        <Route path="/" element={<TokenPage />}></Route>
        <Route path="/about" element={<AboutPage />}></Route>
      </Routes>

      <Footer></Footer>
    </div>
  );
}

export default App;
